// extracted by mini-css-extract-plugin
export var fadeIn = "_mx-1";
export var modalContent = "_mx-3";
export var overlay = "_mx-0";
export var popoverContent = "_mx-2";
export var results = "_mx-5";
export var searchInputWrapper = "_mx-4";